import { Component, OnInit, Input, ViewChild, HostListener, ChangeDetectorRef } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgbPopover, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, RoutingService, AuthService, OccEndpointsService, GlobalMessageService, GlobalMessageType } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription, Subject, forkJoin } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { GeneralPopupComponent } from "src/app/shared/modules/general-popup/general-popup/general-popup.component";
import { SharedService } from "src/app/shared/services/shared.service";
import { CustomInfluenzaService } from "../custom-influenza.service";
import { ProductDetailsInfluenzaComponent } from "../product-details-influenza/product-details-influenza.component";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as _ from 'underscore';
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";

@Component({
  selector: 'app-reservation-sts-details',
  templateUrl: './reservation-sts-details.component.html',
  styleUrls: ['./reservation-sts-details.component.scss']
})
export class ReservationStsDetailsComponent implements OnInit {
  baseUrl: any;
  baseSiteId: any;
  header: any = 'StsShippingSchedule';
  isUpdated: boolean; //by default true, make it false if moving out of flu journey
  showUnits: boolean = true;

  activeSeasonId:any;
  deliveryDate: any = '';
  userData: any = [];
  parentCartId: any;
  
  @Input() reservationNo: string = '';
  reservationStatus: string = '';  //to be blank initially, values- Confirmed, Partially Confirmed, Not Confirmed
  editReservation: boolean = false;      //to be false initially
  cancelSts:boolean =false;
  @ViewChild('confirmModal') modalContent;
  nextRouteUrl: any = '';
  notConfirmedMessage:string = '';

  headerMessage:any;
  programMessage:any;
  remainingUnits:number=0;
  remainingDoses:number=0;
  isCalendarViewOnly:boolean = false;
  isCalendarUpdated:boolean = false; //This will change based on calendar changes ( in case of any error in unit, it is to be made false)

  schedulerStatus:string=''; //This will change based on calendar changes
  isSticky:boolean = false;
  isCartSticky:boolean = false;

  //subscriptions
  activeSeasonSubscriber: Subscription;
  userDataSub: Subscription;
  getCartsApiSubscriber: Subscription;
  fluTimerJourneySub: Subscription;
  navigationEndSub: Subscription;
  FluExtendSub: Subscription;
  authCheckSub: Subscription;
  shippingMainDataSub:Subscription
  shippingCalendarDataSub:Subscription
  fluTimer = 29 * 60 * 1000;  //29min
  selectedType: any;

  frequencyList: any;
  startDate: any;
  endDate: any;  
  stsReservationList: any[];
  stsEnabledProducts: any=[];
  stsProductsJoinedList: any=[];//List of STS products to loop through and show on UI.
  weekData: any[];
  monthsList: any;
  weeksList: any=[];
  jointResponse: any;
  grouped_items: any;
  // showUpdateRow: boolean = false;
  public myMath = Math;
  updateFreqFlag:boolean = false;
  b2bunitID='';

  isEditFlow:boolean = false;
  currentPopover:NgbPopover;
  thresholdError:boolean=false;
  editFreqSub: Subscription;
  saveStsSub: Subscription;
  private destroy$:Subject<void> = new Subject<void>();
  lockMessage: any;
  quickMessage: any;
  onsnUnits =0;
  onsnDoses = 0;
  totalNegativeQtyCounter = 0;

  viewExcelSub: Subscription;
  headerContent:any;
  programContent:any;
  quickContent:any;
  lockContent:any;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    if (window.pageYOffset >= 1100) {
      this.isCartSticky = true;
    } else {
      this.isCartSticky = false;
    }
  }
  
  constructor(
    private baseSiteService: BaseSiteService,
    private readonly ref: ChangeDetectorRef,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly modalService: NgbModal,
    private readonly router: RoutingService,
    private readonly sharedService: SharedService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly user: UserAccountFacade,
    private route: Router,
    private readonly addToCart: CustomAddToCartService,
    private readonly authService: AuthService,
    private readonly sanitizer: DomSanitizer,
    private readonly occEndPoint: OccEndpointsService,
    private readonly globalMessage: GlobalMessageService,
  ) { 
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
  });
  }

  ngOnInit(): void {

    this.schedulerStatus = 'Remaining to schedule';
    this.jointResponse = this.sharedService.getSessionStorage('fluOverviewData'); //reservation details response
    this.isUpdated = true; // may need to change it to false
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.setSeasonId();
    this.checkForExcelDownload();
    //this.checkNavigationAway(); //should not be required - already in view reservation
    //this.checkLogout(); //should not be required - already in view reservation
    this.b2bunitID = this.getB2BUid();

    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userData = res;
        // this.getCartsApi(this.userData.uid);
        this.getShippingCompleteData(this.activeSeasonId, this.b2bunitID);
        this.ref.detectChanges();
        this.userDataSub?.unsubscribe();
      }
    });

  }
  checkForExcelDownload() {
    this.viewExcelSub = this.influenzaService.viewReservationXlsdownload.subscribe((res) => {
      if (res != null && res == 'reservationSchedule') {
        this.downloadExcelNew();
      }
    });
  }

  sanitizeHtmlResponse(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }


  getShippingCompleteData(seasonId, b2bUnitId) {

    let getShippingMainData = this.influenzaService.viewOrderStsShippingMainSectionData(seasonId, b2bUnitId, this.reservationNo);
    let getShippingCalendarData = this.influenzaService.viewOrderStsShippingCalendarSectionData(seasonId, b2bUnitId, this.reservationNo);

    forkJoin([getShippingMainData, getShippingCalendarData])  //takes in array of observables
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {                            //emits array of responses in order once all apis completes in parallel.

        //1 main sectiond data:
        this.headerContent = res[0]?.headerMessage;
        this.headerMessage = this.sanitizeHtmlResponse(this.headerContent);
        this.programContent = res[0]?.programMessage;
        this.programMessage = this.sanitizeHtmlResponse(this.programContent);

        this.quickContent = res[0]?.quickPickMessage;
        this.quickMessage = this.sanitizeHtmlResponse(this.quickContent);

        this.isCalendarViewOnly = res[0]?.isCalenderLocked ? res[0]?.isCalenderLocked : false;
        this.lockContent = res[0]?.lockMessage;
        this.lockMessage = this.sanitizeHtmlResponse(this.lockContent);
        this.ref.detectChanges();

        //2. calendar section data

        this.remainingUnits = res[1]?.totalSTSUnits ? +res[1]?.totalSTSUnits : 0;
        this.remainingDoses = res[1]?.totalSTSDoses ? +res[1]?.totalSTSDoses : 0;

        this.frequencyList = [];
        this.frequencyList = res[1]?.stsFrequency ? res[1]?.stsFrequency : this.getFrequencyDropdown();

        this.startDate = res[1]?.stsTierManagement?.startDate;
        this.endDate = res[1]?.stsTierManagement?.endDate;

        this.stsReservationList = res[1]?.fluStsMap?.reservationSTSData;
        this.stsEnabledProducts = res[1]?.stsEnabledProducts;

        // below variables for edit  case
        let totalNegativeQtyCounterForEdit = 0;
        let totalRemaingUnitsForEdit = 0;
        let totalRemaningDosesForEdit = 0;

        this.stsProductsJoinedList = this.stsReservationList?.map((stsPrdct, index) => {

          //Copying few attributes from 'select vaccine request'
          const matchedJoinedResp = this.jointResponse?.entries?.find(element => element?.product?.code === stsPrdct?.materialNum);
          if (matchedJoinedResp) {
            let thumbNailImg = '';
            if (matchedJoinedResp?.product?.images) {
              const imagesFormat = _.clone(
                _.findWhere(matchedJoinedResp?.product?.images, { format: 'thumbnail' })
              );
              thumbNailImg = imagesFormat?.url;
            }
            stsPrdct['thumbNailImg'] = thumbNailImg;
            stsPrdct['productQuantityValue'] = matchedJoinedResp?.quantity;
            stsPrdct['quantity'] = matchedJoinedResp?.quantity;
            stsPrdct['quantityPerUnit'] = matchedJoinedResp?.product?.quantityPerUnit;
          }

          //prod frequency related
          stsPrdct['selectedFreq'] = undefined;
          stsPrdct['prevSelectedFreq'] = undefined;
          stsPrdct['freqChanged'] = false;
          stsPrdct['frequencyList'] = [...this.frequencyList];
          stsPrdct['prevFrequencyList'] = [...this.frequencyList];

          if (stsPrdct?.sameAsPreviousSeasonEnable) {
            const prevFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'sameaspreviousseason');
            if (!prevFreq) {
              stsPrdct?.frequencyList?.push({
                code: 'sameaspreviousseason',
                name: 'Same as last season'
              });
              stsPrdct?.prevFrequencyList?.push({
                code: 'sameaspreviousseason',
                name: 'Same as last season'
              });
            }
          }

          //Threshold error counter added
          stsPrdct['thresholdErrorCounter'] = 0;
          //Total units count for pdct
          stsPrdct['totalUnitsCount'] = 0
          //Added to create months list -to show accordions
          if (index == 0) {
            this.monthsList = [];
          }
          //Each product month
          stsPrdct?.materialSchedule?.map((item, indx) => {
            //month wise total of product
            item['totalMonthsUnitsCount'] = 0;

            // only from 1st product - we can create the months list 
            if (index == 0) {

              if (item?.stsMonthYear && item?.stsMonthYear != null) {
                let obj = {};
                if (indx <= 2) {
                  obj['showUnits'] = true;
                }
                else {
                  obj['showUnits'] = false;
                }
                obj['monthyear'] = item?.stsMonthYear;
                obj['totalUnits'] = 0;
                obj['totalDoses'] = 0;
                this.monthsList.push(obj);
                //this.weeksList.push(item?.weekList);
              }
            }

            //For view reservation - we need to calculate the totalMonthsUnitsCount & totalUnitsCount
            //each month -> week
            item?.weekList?.map(week => {
              if (week?.finalQty > 0) {
                item['totalMonthsUnitsCount'] += week?.finalQty;
                stsPrdct['selectedFreq'] = week?.freqSelected;
                stsPrdct['prevSelectedFreq'] = week?.freqSelected;
                //15592
                  if(week?.freqSelected){
                    const resetFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'reset');
                    if (!resetFreq) {
                      stsPrdct?.frequencyList?.push({
                        code: 'reset',
                        name: 'Reset'
                      });
                    }
                  }
              }
            });
            //Total of product -> total of each month of that product
            this.monthsList[indx].totalUnits += item['totalMonthsUnitsCount'];
            this.monthsList[indx].totalDoses = this.monthsList[indx].totalUnits * stsPrdct?.quantityPerUnit;
            stsPrdct['totalUnitsCount'] += item['totalMonthsUnitsCount'];

          }); //product's materialSchedule(months) loop ends

          if (stsPrdct['totalUnitsCount'] > 0) {
            stsPrdct['quantity'] = stsPrdct['productQuantityValue'];
            stsPrdct['quantity'] = stsPrdct['quantity'] - stsPrdct['totalUnitsCount'];

            //changing frequency for that product to custom if there is no selected freq and adding reset as option
            if (stsPrdct?.selectedFreq == undefined) {
              stsPrdct['prevFrequencyList'] = [...stsPrdct.frequencyList];
              stsPrdct['prevSelectedFreq'] = stsPrdct['selectedFreq'];
              //changing frequency for that product to custom and adding reset as option
              const customFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'custom');
              if (!customFreq) {
                stsPrdct?.frequencyList?.push({
                  code: 'custom',
                  name: 'Custom'
                });
              }
              const resetFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'reset');
              if (!resetFreq) {
                stsPrdct?.frequencyList?.push({
                  code: 'reset',
                  name: 'Reset'
                });
              }
              stsPrdct['selectedFreq'] = 'custom';
            }
            else if (stsPrdct?.selectedFreq == 'custom') {
              const customFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'custom');
              if (!customFreq) {
                stsPrdct?.frequencyList?.push({
                  code: 'custom',
                  name: 'Custom'
                });
              }
              const resetFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'reset');
              if (!resetFreq) {
                stsPrdct?.frequencyList?.push({
                  code: 'reset',
                  name: 'Reset'
                });
              }
            }
          }

          totalRemaingUnitsForEdit += stsPrdct['quantity'];
          totalRemaningDosesForEdit += stsPrdct['quantity'] * stsPrdct.quantityPerUnit;
          //Updating counter as per each product qty
          if (stsPrdct['quantity'] < 0) {
            totalNegativeQtyCounterForEdit += 1;
          }
          const matchedElement = this.stsEnabledProducts?.find(element => element?.code === stsPrdct?.materialNum);
          return {
            ...stsPrdct,
            ...matchedElement
          };
        }); //product loop ends

        this.calcTotalAndStatusForEditReservation
          (totalNegativeQtyCounterForEdit,
            totalRemaingUnitsForEdit,
            totalRemaningDosesForEdit);
        this.ref.detectChanges();
      }, errors => {
        window.scrollTo(0, 0);
        this.globalMessage.add(errors.message,
          GlobalMessageType.MSG_TYPE_ERROR);
      }); //forkjoin ends                                       
  }

  //called only in case of edit reservation - on landing of page
  calcTotalAndStatusForEditReservation(totalNegativeQtyCounter, totalRemaingUnits, totalRemaningDoses) {
    this.totalNegativeQtyCounter = totalNegativeQtyCounter;
    //case a - no product exceeding
    // if(totalNegativeQtyCounter == 0){
    if (this.totalNegativeQtyCounter == 0) {
      if (totalRemaingUnits == 0) { //all products scheduled
        this.schedulerStatus = 'All units and doses have been scheduled';
        this.remainingUnits = 0;
        this.remainingDoses = 0;
      }
      else if (totalRemaingUnits > 0) {
        this.schedulerStatus = 'Remaining to schedule';
        this.remainingUnits = totalRemaingUnits;
        this.remainingDoses = totalRemaningDoses;
      }
    }
    //case b - atleast 1 product exceeding
    // else if (totalNegativeQtyCounter > 0){
    else if (this.totalNegativeQtyCounter > 0) {
      this.schedulerStatus = 'Exceeds Total';
      totalRemaingUnits = 0;
      totalRemaningDoses = 0;
      this.stsProductsJoinedList?.map((product) => {
        if (product['quantity'] < 0) {
          totalRemaingUnits += product['quantity'];
          totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
        }
      });
      this.remainingUnits = totalRemaingUnits;
      this.remainingDoses = totalRemaningDoses;
    }
    // else {
    //   //console.log('This condition should not occur ideally in edit')
    // }
    //By default in case of view sts - save changes/cancel changes to be kept disabled
    // if(this.schedulerStatus === 'Exceeds Total'){
    //   this.isCalendarUpdated = false;
    // }
    // else{
    //   this.isCalendarUpdated = true;
    // }
    this.ref.detectChanges();
  }


  performQuantityUpdation(event: any, productCode, weekList, weekIndex, monthIndex) {
    let inputValue = (event?.target as HTMLInputElement)?.value;
    //const digitsRegex = /^\d+$/;
    // if(!digitsRegex.test(inputValue)){
    //   return;
    // }
    if (inputValue == '') {
      inputValue = '0';
    }
    //removing leading zeros
    if (inputValue?.length > 1 && inputValue?.startsWith('0')) {
      inputValue = inputValue.replace(/^0+/, '');
      (event.target as HTMLInputElement).value = inputValue;
    }
    // //max value restrict as max attribute not working
    // if(inputValue?.length > 4){
    //   inputValue = '9999';
    //   (event.target as HTMLInputElement).value = inputValue;
    //   this.ref.detectChanges();
    // }

    if (+inputValue >= 0) {
      // let totalNegativeQtyCounter = 0;
      this.totalNegativeQtyCounter = 0;
      let totalRemaingUnits = 0;
      let totalRemaningDoses = 0;

      // //threshold errror counter
      // let thresholdErrorCounter = 0; // creating at product level

      this.monthsList[monthIndex].totalUnits = 0;
      this.monthsList[monthIndex].totalDoses = 0;

      this.stsProductsJoinedList?.map((product) => {
        if (product.materialNum === productCode) {
          product['prevFrequencyList'] = [...product.frequencyList];
          product['prevSelectedFreq'] = product['selectedFreq'];
          //changing frequency for that product to custom and adding reset as option
          if (product?.selectedFreq !== 'custom') {
            const customFreq = product?.frequencyList?.find(freq => freq.code === 'custom');
            if (!customFreq) {
              product?.frequencyList?.push({
                code: 'custom',
                name: 'Custom'
              });
            }
            const resetFreq = product?.frequencyList?.find(freq => freq.code === 'reset');
            if (!resetFreq) {
              product?.frequencyList?.push({
                code: 'reset',
                name: 'Reset'
              });
            }
            product['selectedFreq'] = 'custom';
            this.ref.detectChanges();
          }

          product['totalUnitsCount'] = 0;
          product?.materialSchedule?.map((item, index) => {
            item['monthThreshold'] = 0;
            item['totalMonthsUnitsCount'] = 0;
            item?.weekList?.map((week, indxx) => {
              if (index == monthIndex && indxx == weekIndex) {
                item['monthThreshold'] = week?.qtyThreshold; //month threshold set as per input week.
              }
              if (week?.finalQty > 0) {
                item['totalMonthsUnitsCount'] += week?.finalQty;
                week['freqSelected'] = 'custom';
              }
            });
            if (index == monthIndex) {
              this.monthsList[index].totalUnits += item['totalMonthsUnitsCount'];
              this.monthsList[index].totalDoses = this.monthsList[index].totalUnits * product?.quantityPerUnit;
            }
            product['totalUnitsCount'] += item['totalMonthsUnitsCount'];

            //Threshold check for the month whose input is changed
            if (index == monthIndex) {
              let remainingQtyForProduct = product['productQuantityValue'] - (product['totalUnitsCount'] - item['totalMonthsUnitsCount']);
              if (remainingQtyForProduct < 0) {
                remainingQtyForProduct = 0;
              }
              if (remainingQtyForProduct < item['monthThreshold']) {
                item['monthThreshold'] = remainingQtyForProduct;
              }
              // in case for the month, total units is more than threshold, show popover for the week which made the threshold going more if not 0
              if (item['totalMonthsUnitsCount'] > item['monthThreshold']) {
                item?.weekList?.map((week, indxxx) => {
                  if (indxxx == weekIndex) {
                    let exceedsPopoverElement;
                    if (week?.finalQty > 0) {
                      if (!week['showpopover']) { //opening popover and increasing counter only popover not opened
                        week['showpopover'] = true;
                        week['thresholdError'] = true;
                        // this.thresholdError = true;
                        product['thresholdErrorCounter'] += 1;
                        exceedsPopoverElement = document.getElementById('exceedsPopoverOpen-' + product?.materialNum + '-' + monthIndex + '-' + weekIndex);
                        this.ref.detectChanges();
                      }
                    }
                    else { // qty for the week made 0 but still total count for month > threshold
                      if (week['showpopover']) {
                        week['showpopover'] = false;
                        week['thresholdError'] = false;
                        product['thresholdErrorCounter'] -= 1;
                        exceedsPopoverElement = document.getElementById('exceedsPopoverClose-' + product?.materialNum + '-' + monthIndex + '-' + weekIndex);
                        this.ref.detectChanges();
                      }
                    }
                    if (exceedsPopoverElement) {
                      exceedsPopoverElement.click(); //opens popover if count >0
                    }
                  }
                });
              }
              else { // in case for the month, total units is less than threshold, close all popovers which are opened for that month
                item?.weekList?.map((week, indx) => {
                  if (week['showpopover']) {
                    const exceedsPopoverElement = document.getElementById('exceedsPopoverClose-' + product?.materialNum + '-' + monthIndex + '-' + indx);
                    if (exceedsPopoverElement) {
                      exceedsPopoverElement.click();    //closes popover
                    }
                    week['showpopover'] = false;
                    week['thresholdError'] = false;
                    product['thresholdErrorCounter'] -= 1;
                    this.ref.detectChanges();
                  }
                });
                // this.thresholdError = false;
                this.ref.detectChanges();
              }
            }
          });
          if (product['totalUnitsCount'] >= 0) {
            product['quantity'] = product['productQuantityValue'];
            product['quantity'] = product['quantity'] - product['totalUnitsCount'];
          }
        }
        //For other products whose input not changed - totalMonthsUnitsCount/totalUnitsCount remain same as before
        else {
          product?.materialSchedule?.map((item, index) => {
            if (index == monthIndex) {
              this.monthsList[index].totalUnits += item['totalMonthsUnitsCount'];
              this.monthsList[index].totalDoses = this.monthsList[index].totalUnits * product?.quantityPerUnit;
            }
          });
        }
        // calculating remaining total units/doses
        totalRemaingUnits += product['quantity'];
        totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
        //Updating counter as per each product qty
        if (product['quantity'] < 0) {
          // totalNegativeQtyCounter +=1;
          this.totalNegativeQtyCounter += 1;
        }
      });

      const sumValues = { totalUnitsSum: 0, thresholdCounterSum: 0 };
      const thresholdAndTotalSum = this.stsProductsJoinedList.reduce((accumulator, currentObj) => {
        return {
          totalUnitsSum: accumulator.totalUnitsSum + currentObj.totalUnitsCount,
          thresholdCounterSum: accumulator.thresholdCounterSum + currentObj.thresholdErrorCounter,
        }
      }, sumValues);
      if (thresholdAndTotalSum?.thresholdCounterSum > 0) {
        this.thresholdError = true;
      }
      else {
        this.thresholdError = false;
      }
      // const thresholdCounterSum = this.stsProductsJoinedList.reduce((accumulator,currentObj)=>{
      //   return accumulator + currentObj.thresholdErrorCounter;
      // },0);
      // if(thresholdCounterSum >0){
      //   this.thresholdError = true;
      // }
      // else{
      //   this.thresholdError = false;
      // }

      //case a - no product exceeding
      // if(totalNegativeQtyCounter == 0){
      if (this.totalNegativeQtyCounter == 0) {
        if (totalRemaingUnits == 0) { //all products scheduled
          this.schedulerStatus = 'All units and doses have been scheduled';
          this.remainingUnits = 0;
          this.remainingDoses = 0;
        }
        else if (totalRemaingUnits > 0) {
          this.schedulerStatus = 'Remaining to schedule';
          this.remainingUnits = totalRemaingUnits;
          this.remainingDoses = totalRemaningDoses;
        }
      }
      //case b - atleast 1 product exceeding
      // else if (totalNegativeQtyCounter > 0){
      else if (this.totalNegativeQtyCounter > 0) {
        this.schedulerStatus = 'Exceeds Total';
        totalRemaingUnits = 0;
        totalRemaningDoses = 0;
        //sum of all negative values only becomes total and doses
        //Will have to check later if below can be done without extra map method
        this.stsProductsJoinedList?.map((product) => {
          if (product['quantity'] < 0) {
            totalRemaingUnits += product['quantity'];
            totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
          }
        });
        this.remainingUnits = totalRemaingUnits;
        this.remainingDoses = totalRemaningDoses;
      }
      // else {
      //  // console.log('This condition should not occur ideally')
      // }

      if (this.schedulerStatus === 'Exceeds Total' || thresholdAndTotalSum?.totalUnitsSum == 0) {
        this.isCalendarUpdated = false;
      }
      else {
        this.isCalendarUpdated = true;
      }
      this.ref.detectChanges();
    }
  }

  togglePopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
    }
    if (this.currentPopover.isOpen()) {
      this.currentPopover.close();
    } else {
      this.currentPopover.open();
    }
  }

  closePopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
      if (this.currentPopover.isOpen()) {
        this.currentPopover.close();
      }
    }
  }
  openPopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
      if (!this.currentPopover.isOpen()) {
        this.currentPopover.open();
      }
    }
  }

  frequencyChange(event: any, stsProdData) {
    stsProdData['freqChanged'] = true;
    if (event !== 'reset') {
      const resetFreq = stsProdData?.frequencyList?.find(freq => freq.code === 'reset');
      if (!resetFreq) {
        stsProdData?.frequencyList?.push({
          code: 'reset',
          name: 'Reset'
        });
      }
    }
    this.updateFreqFlag = true;
    this.ref.detectChanges();
  }

  updateCalendar() {
    if (this.updateFreqFlag) {
      let stsFrequency = [];
      //loop through list, prepare the req
      this.stsProductsJoinedList.map(product => {
        //except custom, all options considered, even reset and sent in request
        if (product.selectedFreq
          && product.selectedFreq !== 'custom'
          && product.freqChanged) { //request to be sent only for product whose dropdown was changed
          let obj = {
            "productCode": product?.materialNum,
            "selectedFrequency": product.selectedFreq,
            "startDate": this.startDate,
            "endDate": this.endDate
          }
          stsFrequency?.push(obj);
        }
      });
      let finalReqBody = {
        "stsFrequencyUpdate": stsFrequency
      }

      let editFrequencyApi = this.influenzaService.changeOrderStsFrequencyCalendarSectionData(this.activeSeasonId, this.b2bunitID, finalReqBody, this.reservationNo);
      this.editFreqSub = editFrequencyApi.subscribe(res => {
        if (res && res !== null) {
          //update the details in the stsProductsJoinedList.
          //total units and total doses for each month to be recaculated based on api response. so setting previous values to 0
          this.monthsList?.map(month => {
            month.totalUnits = 0;
            month.totalDoses = 0;
          });
          //Need to recalculate Total remaining units/doses
          // let totalNegativeQtyCounter = 0;
          this.totalNegativeQtyCounter = 0;
          let totalRemaingUnits = 0;
          let totalRemaningDoses = 0;

          this.stsProductsJoinedList?.map(stsProd => {
            const matchedElement = res?.reservationSTSData?.find(entry => entry?.materialNum === stsProd?.materialNum);
            if (matchedElement) {
              //totalUnitsCount for changed freq product to be recalculated
              stsProd['totalUnitsCount'] = 0;

              //For the product whose frequency is updated and all doses scheduled and updated from backend
              stsProd['thresholdErrorCounter'] = 0;

              stsProd?.materialSchedule?.map(existingMaterial => {
                const matchedSchedule = matchedElement?.materialSchedule?.find(newMaterial => newMaterial?.stsMonthYear === existingMaterial?.stsMonthYear);

                if (matchedSchedule) {
                  // existingMaterial = matchedSchedule; //material schedule copied from new to old
                  //Above will cause issue while looping not sure, so copying individual attributes:
                  existingMaterial.maxThresholdAllowed = matchedSchedule?.maxThresholdAllowed;
                  existingMaterial.remThres = matchedSchedule?.remThres;
                  existingMaterial.sameAsPreviousSeason = matchedSchedule?.sameAsPreviousSeason;
                  existingMaterial.unassignedThres = matchedSchedule?.unassignedThres;
                  //below causing weeks sorting to go opposite due to backend response
                  // existingMaterial.weekList = [...matchedSchedule?.weekList];

                  //Loop ,compare and assign
                  // existingMaterial?.weekList.map(week =>{
                  //   const matchedWeek = matchedSchedule?.weekList?.find(newWeek => newWeek?.stsMonthYear === existingMaterial?.stsMonthYear);
                  // });

                  //or sort the list first and then assign
                  matchedSchedule?.weekList?.sort((a, b) => {
                    const dateA = new Date(a.startMonday);
                    const dateB = new Date(b.startMonday);
                    return dateA.getTime() - dateB.getTime();
                  });
                  existingMaterial.weekList = [...matchedSchedule?.weekList];

                  //1. recalculating totalMonthsUnitsCount for the month for that product
                  existingMaterial.totalMonthsUnitsCount = 0;
                  existingMaterial.weekList.map(week => {
                    if (week.finalQty > 0) {
                      existingMaterial.totalMonthsUnitsCount += week?.finalQty;
                    }
                  });

                  //2. update monthsList total units and total doses based on new data
                  let matchedMonth = this.monthsList?.find(month => month.monthyear === existingMaterial?.stsMonthYear);
                  if (matchedMonth) {
                    matchedMonth.totalUnits += existingMaterial['totalMonthsUnitsCount'];
                    matchedMonth.totalDoses = matchedMonth.totalUnits * stsProd['quantityPerUnit'];
                  }
                  //3. recalculate totalUnitsCount for the product
                  stsProd['totalUnitsCount'] += existingMaterial['totalMonthsUnitsCount'];
                }
              }); //materialSchedule loop ends
              //4. recalculate quantity for the product
              if (stsProd['totalUnitsCount'] >= 0) {
                stsProd['quantity'] = stsProd['productQuantityValue'];
                stsProd['quantity'] = stsProd['quantity'] - stsProd['totalUnitsCount'];
              }
            }
            else {//For other products whose freq not changed - totalMonthsUnitsCount/totalUnitsCount remain same as before
              stsProd?.materialSchedule?.map((existingMaterial) => {
                let matchedMonth = this.monthsList?.find(month => month.monthyear === existingMaterial?.stsMonthYear);
                if (matchedMonth) {
                  matchedMonth.totalUnits += existingMaterial['totalMonthsUnitsCount'];
                  matchedMonth.totalDoses = matchedMonth.totalUnits * stsProd['quantityPerUnit'];
                }
              });
            }
            //5. calculating remaining total units/doses
            totalRemaingUnits += stsProd['quantity'];
            totalRemaningDoses += stsProd['quantity'] * stsProd.quantityPerUnit;
            //Updating counter as per each product qty
            if (stsProd['quantity'] < 0) {
              // totalNegativeQtyCounter +=1;
              this.totalNegativeQtyCounter += 1;
            }

            //if any product freq selection was reset, remove that option
            if (stsProd.selectedFreq == 'reset') {
              //removing reset & custom option if present
              stsProd.frequencyList = stsProd?.frequencyList?.filter(freq => freq.code !== 'reset' && freq.code !== 'custom');
              stsProd.selectedFreq = undefined; //setting selected freq to none 
            }
            else {
              //removing custom if present in case some other freq selected
              const customFreq = stsProd?.frequencyList?.find(freq => freq.code === 'custom');
              if (customFreq) {
                stsProd.frequencyList = stsProd?.frequencyList?.filter(freq => freq.code !== 'custom');
              }
            }

            //updating prev selected freq & list 
            stsProd['prevSelectedFreq'] = stsProd['selectedFreq'];
            stsProd['prevFrequencyList'] = [...stsProd.frequencyList];
            stsProd['freqChanged'] = false;
          }); //prod loop ends
          //Added for threshold error check

          const sumValues = { totalUnitsSum: 0, thresholdCounterSum: 0 };
          const thresholdAndTotalSum = this.stsProductsJoinedList.reduce((accumulator, currentObj) => {
            return {
              totalUnitsSum: accumulator.totalUnitsSum + currentObj.totalUnitsCount,
              thresholdCounterSum: accumulator.thresholdCounterSum + currentObj.thresholdErrorCounter,
            }
          }, sumValues);

          if (thresholdAndTotalSum?.thresholdCounterSum > 0) {
            this.thresholdError = true;
          }
          else {
            this.thresholdError = false;
          }
          //case a - no product exceeding
          // if(totalNegativeQtyCounter == 0){
          if (this.totalNegativeQtyCounter == 0) {
            if (totalRemaingUnits == 0) { //all products scheduled
              this.schedulerStatus = 'All units and doses have been scheduled';
              this.remainingUnits = 0;
              this.remainingDoses = 0;
            }
            else if (totalRemaingUnits > 0) {
              this.schedulerStatus = 'Remaining to schedule';
              this.remainingUnits = totalRemaingUnits;
              this.remainingDoses = totalRemaningDoses;
            }
          }
          //case b - atleast 1 product exceeding
          // else if (totalNegativeQtyCounter > 0){
          else if (this.totalNegativeQtyCounter > 0) {
            this.schedulerStatus = 'Exceeds Total';
            totalRemaingUnits = 0;
            totalRemaningDoses = 0;
            //sum of all negative values only becomes total and doses
            //Will have to check later if below can be done without extra map method
            this.stsProductsJoinedList?.map((product) => {
              if (product['quantity'] < 0) {
                totalRemaingUnits += product['quantity'];
                totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
              }
            });
            this.remainingUnits = totalRemaingUnits;
            this.remainingDoses = totalRemaningDoses;
          }
          // else {
          //  // console.log('This condition should not occur ideally')
          // }
          if (this.schedulerStatus === 'Exceeds Total' || thresholdAndTotalSum?.totalUnitsSum == 0) {
            this.isCalendarUpdated = false;
          }
          else {
            this.isCalendarUpdated = true;
          }
          this.ref.detectChanges();
        } //if res ends
      },
        errors => {
          window.scrollTo(0, 0);
          this.globalMessage.add(errors.message, GlobalMessageType.MSG_TYPE_ERROR);
        }); //api res ends
      this.updateFreqFlag = false;
      this.ref.detectChanges();
    } //updateFreqFlag if ends
  }

  cancelUpdateCalendar() {
    //reverting back the frequency list and selected freq
    this.stsProductsJoinedList?.map((stsProd) => {
      if (stsProd['freqChanged']) {
        stsProd['selectedFreq'] = stsProd['prevSelectedFreq'];
        stsProd['frequencyList'] = [...stsProd.prevFrequencyList];
        stsProd['freqChanged'] = false;
      }
    });
    this.updateFreqFlag = false;
    this.ref.detectChanges();
  }

  transformWeek(week) {
    if (week && week != null) {
      const parts = week?.split('/');
      if (parts?.length === 3) {
        return `${parts[0]}/${parts[1]}`;
      }
      else {
        return week;
      }
    }
  }

  getFrequencyDropdown() {
    this.frequencyList = [{
      name: 'Weekly',
      code: 'Onceperweek'
    },
    {
      name: 'Monthly',
      code: 'Oncepermonth'
    },
    {
      name: 'Twice a month',
      code: 'Twicepermonth'
    },
    ];
  }


  saveChanges() {
    let stsData = [];
    this.stsProductsJoinedList.map(product => {
      if (product?.productQuantityValue > 0) {
        let obj = {
          "materialNum": product?.materialNum,
          "materialSchedule": product?.materialSchedule
        }
        stsData?.push(obj);
      }
    });
    let finalReqBody = {
      "reservationSTSData": stsData
    }

    let saveStsApi = this.influenzaService.changeStsOrder(this.activeSeasonId, this.b2bunitID, finalReqBody, this.reservationNo);
    this.saveStsSub = saveStsApi.subscribe(res => {
      if (res && res !== null) {
        // action to be done post save?
        this.isCalendarUpdated = false; //so that post save, saveChanges & cancelChanges button is disabled!
        this.ref.detectChanges();
      }
    }, errors => {
      window.scrollTo(0, 0);
      this.globalMessage.add(errors.message, GlobalMessageType.MSG_TYPE_ERROR);
    });
  }

  cancelChanges() {
    this.getShippingCompleteData(this.activeSeasonId, this.b2bunitID); //to reload the data
  }

  closePopup() {
    this.modalService.dismissAll();
  }

  backToDashBoard() {
    this.router.goByUrl('influenza/dashboard');
  }
  downloadExcel() {
    let jsonArrayData = [];
    for (let prod of this.stsProductsJoinedList) {
      let jsonObj = {}
      jsonObj['Customer'] = this.b2bunitID;
      jsonObj['Material'] = prod?.materialNum;
      jsonObj['Frequency'] = prod?.selectedFreq ? prod?.selectedFreq : 'No frequency selected';
      jsonObj['Units/Doses'] = prod?.totalUnitsCount + '/' + prod?.totalUnitsCount * prod?.quantityPerUnit;

      jsonArrayData.push(jsonObj);
    }
    let fileName = 'STS_details_' + this.reservationNo;
    this.addToCart.downloadXls(jsonArrayData, fileName);
  }

  downloadExcelNew() {

    let arrayOfHeadings = ['Customer', '', 'Material', 'Frequency', 'Total Units/Doses'];
    let arrayOfMaterials = [];
    this.stsProductsJoinedList.map((stsProd, index) => {
      let materialArr = [];
      if (index == 0) {
        materialArr.push(this.b2bunitID);
      }
      else {
        materialArr.push('');
      }
      // materialArr.push('');
      materialArr.push('Requested Quantity');
      materialArr.push(stsProd?.materialNum);
      let selectedFreq = stsProd?.selectedFreq ? stsProd?.selectedFreq : 'No frequency selected';
      materialArr.push(selectedFreq);
      // let totalUnitsDoses = stsProd?.totalUnitsCount+'/'+stsProd?.totalUnitsCount*stsProd?.quantityPerUnit;
      let totalUnitsDoses = stsProd?.productQuantityValue + '/' + stsProd?.productQuantityValue * stsProd?.quantityPerUnit;
      materialArr.push(totalUnitsDoses);
      //product's months
      stsProd?.materialSchedule?.map((item, indx) => {
        if (index == 0) {   //headings array can be created using 1st product
          arrayOfHeadings.push('');
          arrayOfHeadings.push(item?.stsMonthYear);
        }
        materialArr.push('');
        materialArr.push('');
        //weeks in product's month
        item?.weekList?.map(week => {
          if (index == 0) {
            const weekDate = this.transformWeek(week?.startMonday);
            arrayOfHeadings.push(weekDate);
          }
          // materialArr.push(week?.finalQty);
          let weekUnitDoses = week?.finalQty + '/' + week?.finalQty * stsProd?.quantityPerUnit;
          materialArr.push(weekUnitDoses);
        });
        materialArr.push(''); //empty for total monthly count for product. Total monthly count is added to last column
        if (index == 0) {
          arrayOfHeadings.push('Total Units/Doses');
        }
      });
      arrayOfMaterials.push(materialArr);
    });
    //Added to have another column for total monthly count at last column
    this.stsProductsJoinedList.map((stsProd, index) => {
      let materialArr = [];
      if (index == 0) {
        materialArr.push('', '', '', '', '');
        stsProd?.materialSchedule?.map((item, indx) => {
          materialArr.push('', '');
          item?.weekList?.map(week => {
            materialArr.push('');
          });
          let monthUnitDoses = this.monthsList[indx].totalUnits + '/' + this.monthsList[indx].totalDoses;
          materialArr.push(monthUnitDoses);
        });
        arrayOfMaterials.push(materialArr);
      }
    });
    let fileName = 'STS_details_' + this.reservationNo;
    this.generateExcelFile(arrayOfHeadings, arrayOfMaterials, fileName);
  }
  generateExcelFile(arrayOfHeadings: any[], arrayOfMaterials: any[], fileName: string): void {
    let arrayOfMonths = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
    // new workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // new worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);

    const maxArrayLength = arrayOfHeadings.length; // no of rows

    // Loop through the arrays and add data to the worksheet column by column
    for (let i = 0; i < maxArrayLength; i++) {
      const rowData = [];
      rowData.push(arrayOfHeadings[i] || '');
      arrayOfMaterials.forEach(materialArr => {
        rowData.push(materialArr[i]);
      });
      // Add the data to the worksheet
      XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: `A${i + 1}` });

      //Making Months bold
      if (arrayOfHeadings[i] !== '') {
        const parts = arrayOfHeadings[i]?.split(' ');
        if (parts?.length > 0) {
          const heading = parts[0];
          if (arrayOfMonths?.includes(heading?.toLowerCase())) {
            for (let col = 0; col < rowData.length; col++) {
              const cellAddress = XLSX.utils.encode_cell({ r: i, c: col });
              ws[cellAddress].s = {};
              ws[cellAddress].s.font = {};
              ws[cellAddress].s.font.bold = true;
            }
          }
        }
      }
    }

    //setting fixed width for each column
    let noOfColumns = arrayOfMaterials?.length + 1;
    ws['!cols'] = Array(noOfColumns).fill({ width: 15 })

    //worksheet added to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'STS_details');

    //blob containing the Excel file data
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName, true);
  }

  saveAsExcelFile(buffer: any, fileName: string, filename_change_not_needed?: boolean): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    if (!!filename_change_not_needed) {
      FileSaver.saveAs(
        data,
        fileName + EXCEL_EXTENSION
      );
    } else {
      FileSaver.saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    }
  }


  OnPrint() {
    window.print();
  }

  setSeasonId() {
    const seasonID = this.sharedService.getSessionStorage('activeSeasons');
    if (seasonID) {
      this.activeSeasonId = seasonID;
    }
    else {
      this.activeSeasonSubscriber = this.influenzaService.activeSeaons.subscribe((response) => {
        if (response) {
          response?.categoryData?.forEach((season) => {
            if (season['defaultSeason']) {
              this.activeSeasonId = season['code'];
            }
          });
          if (this.activeSeasonId === undefined || this.activeSeasonId === null) {
            this.activeSeasonId = response?.categoryData?.[0]?.code;    //assigning 1st index as the last resort
          }
          this.activeSeasonSubscriber?.unsubscribe();
          this.ref.detectChanges();
        }
      });
    }
  }

  numberCheck(event) {
    const charCode = event.which ? event.which : event.keyCode;
    let inputValue = (event?.target as HTMLInputElement)?.value;
    if (inputValue?.length > 3) {
      return false;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkBlank(event) {
    let inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '') {
      (event.target as HTMLInputElement).value = '0';
    }
  }

  getB2BUid() {
    let b2bUid: string;
    if ('selectedLocations' in sessionStorage) {
      b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber;
    }
    else {
      //default location
      b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0].accountNumber;
    }
    return b2bUid;
  }

  checkFluTimerCompletion() {
    this.fluTimerJourneySub = this.influenzaService.fluTimerCompletedSubject.subscribe((res) => {
      //timer of 30mins completed. show popup
      if (res) {
        //show popup
        this.showFluExtendPopup();
      }
    })
  }
  showFluExtendPopup() {
    const modalRef = this.modalService.open(GeneralPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `fluLockExtendModal ${this.baseSiteId}`
    });
    modalRef.componentInstance.popup_title = 'Influenza Session Expiry';
    modalRef.componentInstance.popup_content = 'Your Influenza session is about to expire.<br />Do you want to continue on Influenza page?';
    modalRef.componentInstance.continueCancelButtons = true;
    this.FluExtendSub = modalRef.componentInstance.extendOrCancelEvent.subscribe((res) => {
      //if extend clicked, extend timer, else navigate to dashboard.
      if (res === 'extend') {
        this.extendLock();
        this.influenzaService.extendFluJourneyTimer(this.fluTimer);
      }
      else {
        this.router.goByUrl('influenza/dashboard'); //lock will be released on checkNavigationAway
      }
    });
  }

  extendLock() {
    const params = {
      "requstType": 'EXTENDLOCK',    //UNLOCK to unlock
      "orderNumber": this.reservationNo  //this.reservationNo sample - 1092000246
    }

    this.influenzaService.fluLockOrUnlock(this.userData.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessageNo = res.messageNumber;
          //S+003=LOCKED (EXTEND also), S+002=unlocked, E-005(order not found)=alreadyLocked
          if (lockStatus === 'S' && lockMessageNo === '003') {
          }
          // else {
          //  // console.log('lock extend fail');
          // }
        }
      }, errors => {
        //console.log('unlock api fail', errors);
      })
  }


  releaseLock() {
    const params = {
      "requstType": 'UNLOCK',    //UNLOCK to unlock
      "orderNumber": this.reservationNo  //this.reservationNo sample - 1092000246
    }
    this.influenzaService.fluLockOrUnlock(this.userData.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessage = res.message;
          const lockMessageNo = res.messageNumber;
          //S+003=LOCKED, S+002=unlocked, E-005(order not found)=alreadyLocked
          if (lockStatus === 'S' && lockMessageNo === '002') {
            this.influenzaService.endFluJourneyTimer();
          }
          // else {
          //  // console.log('unlock fail', lockMessage); //scenario??
          // }
        }
      }, errors => {
        //console.log('unlock api fail', errors);
      });
  }


  checkNavigationAway() {
    this.navigationEndSub = this.route.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const nextRoute = event.url; //next route URL
          if (this.isUpdated) {
            if (nextRoute?.includes('fluCategoryPage')
              || nextRoute?.includes('FluverifypaymentPage')
              || nextRoute?.includes('fluStsLandingPage')) { //add more urls if required.
              //no action needed & dont release lock
              //may need to remove influenza dashboard from here.
              if (this.editReservation && nextRoute?.includes('influenza/dashboard')) {
                this.releaseLock();
                if (this.parentCartId) {
                  this.addToCart.clearCartWithoutReload(this.parentCartId);
                }
              }
            }
            else {
              //stop navigation and show popup
              this.route.navigate([], { skipLocationChange: true });
              this.nextRouteUrl = nextRoute;
              this.modalService.open(this.modalContent, {
                centered: true,
                backdrop: 'static',
                windowClass: `confirmLeaveModal ${this.baseSiteId}`
              });
              //if continue clicked on popup, then redirect to next route (and release lock) ,else stay and do nothing
            }
          }
          else {
            //release lock if edit reservation case
            if (this.editReservation) {
              this.releaseLock();
              if (this.parentCartId) {
                this.addToCart.clearCartWithoutReload(this.parentCartId);
              }
            }
            else {
              if (this.parentCartId) {
                this.addToCart.clearCartWithoutReload(this.parentCartId);
              }
            }
          }
        }
      });
  }

  checkLogout() {
    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        if (this.editReservation) {
          this.releaseLock();//AccessDeniedError might come at this time
        }
        this.authCheckSub = this.authService.isUserLoggedIn().subscribe((res2) => {
          if (!res2) {
            this.sharedService.removeSessionStorage('fluData');
            this.sharedService.removeSessionStorage('estimateData');
            this.sharedService.removeSessionStorage('isEditFlu');
            this.sharedService.removeSessionStorage('contractPrices');
            this.authCheckSub?.unsubscribe();
          }
        });
      }
    });
  }

  productDetails(productDetails, i): void {
    const modalRef = this.modalService.open(ProductDetailsInfluenzaComponent, {
      windowClass: `product-details-inf-modal ${this.baseSiteId}`
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = productDetails.code;
  }

  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.getCartsApiSubscriber?.unsubscribe();
    this.navigationEndSub?.unsubscribe();
    this.fluTimerJourneySub?.unsubscribe();
    this.FluExtendSub?.unsubscribe();
    this.editFreqSub?.unsubscribe();
    this.saveStsSub?.unsubscribe();
    this.viewExcelSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
